// src/index.js
import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import Dashboard from './Components/Dashboard'
import BusinessLine from './Components/BusinessLine'
import OrgContact from './Components/OrgContact'
import AddClientContact from './Components/Forms/AddClientContact'
import ClientContact from './Components/ClientContact'
import ClientProfile from './Components/ClientProfile'
import Lead from './Components/Lead'
import EditMember from './Components/Forms/EditMember'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import Login1 from './Components/login/Login1'
import ViewLeads from './Components/ViewLeads'
import { Provider } from 'react-redux'
import appStore from './Components/utils/redux/appStore'
import Model from './Components/Model'
import EditClientContact from './Components/Forms/EditClientContact'
import LeadProfile from './Components/LeadProfile'
import ProtectedRoute from './Components/utils/ProtectedRoutes'
import RedirectLoggedIn from './Components/utils/RedirectToLogin'
import AddExpense from './Components/AddExpense'
import ViewExpense from './Components/ViewExpense'
import StoreHome from './Components/StoreHome'
import StoreDetails from './Components/StoreDetails'
import BatchDetails from './Components/BatchDetails'
import ViewSalesOrder from './Components/ViewSalesOrder'
import SoDetails from './Components/SoDetails'
import UpdatePassword from './Components/UpdatePassword'
import VerifyOtp from './Components/login/VerifyOtp'

// CacheBuster imports
import CacheBuster from 'react-cache-buster'
import packageJson from '../package.json'
import CreateDI from './Components/CreateDI'
import ViewSoInvoice from './Components/ViewSoInvoice'
import Di from './Components/Di'
import Reports from './Components/Report'
import OrderBookingReport from './Components/Reports/OrderBookingReport'
import LeadDetailsReport from './Components/Reports/LeadDetailsReport'
import InvoiceReport from './Components/Reports/InvoiceReport'
import AggInvoiceReport from './Components/Reports/AggInvoiceReport'
import AggCreditNoteReport from './Components/Reports/AggCreditNoteReport'
import Invoice from './Components/Invoice'
import Store from './Components/Store'
import FOC from './Components/FOC'
import FocLeadJourney from './Components/FocLeadJourney'
import ViewFocSalesOrder from './Components/ViewFocSalesOrder'
import FocSoDetails from './Components/FocSoDetails'
import ViewFocSoInvoice from './Components/ViewFocSoInvoice'
import FocDi from './Components/FocDi'
import PurchaseRequest from './Components/Purchase/PurchaseRequest'
import ViewPR from './Components/Purchase/ViewPR'
import PRDetail from './Components/Purchase/PRDetail'
import AddVendor from './Components/Purchase/Vendor/AddVendor'
import ViewVendors from './Components/Purchase/Vendor/ViewVendors'
import CreateQuotation from './Components/Purchase/Quotation/CreateQuotation'
import ViewQuotation from './Components/Purchase/Quotation/ViewQuotation'
import ViewPO from './Components/Purchase/ViewPo'
import ViewWorkOrder from './Components/Purchase/ViewWorkOrder'
import MaterialInspection from './Components/Purchase/MaterialInspection'
import ViewDebitNotes from './Components/Purchase/ViewDebitNotes'
const { version } = packageJson

const isProduction = process.env.NODE_ENV === 'production'

const appRouter = createBrowserRouter([
  {
    path: '/',
    element: (
      <RedirectLoggedIn
        element={
          <Provider store={appStore}>
            <Login1 />
          </Provider>
        }
      />
    )
  },
  {
    path: '/verify-otp',
    element: (
      <RedirectLoggedIn
        element={
          <Provider store={appStore}>
            <VerifyOtp />
          </Provider>
        }
      />
    )
  },
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/dashboard',
        element: <ProtectedRoute element={<Dashboard />} />
      },
      {
        path: '/business_line',
        element: <ProtectedRoute element={<BusinessLine />} />
      },
      {
        path: '/org_contact',
        element: <ProtectedRoute element={<OrgContact />} />
      },
      {
        path: '/add_client_contact',
        element: (
          <ProtectedRoute element={<AddClientContact assignToLead={false} />} />
        )
      },
      {
        path: '/client_contact',
        element: <ProtectedRoute element={<ClientContact />} />
      },
      {
        path: '/client_profile/:resid',
        element: <ProtectedRoute element={<ClientProfile />} />
      },
      {
        path: '/client_profile/:resid/lead/:resid',
        element: (
          <ProtectedRoute
            element={
              <Lead
                condition={true}
                leadType='new_lead'
                tabValue='capture_details'
              />
            }
          />
        )
      },
      {
        path: '/lead',
        element: (
          <ProtectedRoute
            element={
              <Lead
                condition={true}
                leadType='new_lead'
                tabValue='capture_details'
              />
            }
          />
        )
      },
      {
        path: '/leads/:id',
        element: (
          <ProtectedRoute
            element={<Lead condition={false} leadType='existing_lead' />}
          />
        )
      },
      {
        path: '/view_leads',
        element: <ProtectedRoute element={<ViewLeads />} />
      },
      {
        path: '/org_contact/edit_resources/:resid',
        element: <ProtectedRoute element={<EditMember />} />
      },
      {
        path: '/client_contact/edit_client/:resid',
        element: <ProtectedRoute element={<EditClientContact />} />
      },
      {
        path: '/model/:productLineId/:businessLineId',
        element: <ProtectedRoute element={<Model />} />
      },
      {
        path: '/client_profile/:resid/lead_details/:leadId',
        element: <ProtectedRoute element={<LeadProfile />} />
      },
      {
        path: '/lead_details/:leadId',
        element: <ProtectedRoute element={<LeadProfile />} />
      },
      {
        path: '/add_expense',
        element: <ProtectedRoute element={<AddExpense />} />
      },
      {
        path: '/view_expense',
        element: <ProtectedRoute element={<ViewExpense />} />
      },
      {
        path: '/view_so',
        element: <ProtectedRoute element={<ViewSalesOrder />} />
      },
      {
        path: '/view_so/:soid',
        element: <ProtectedRoute element={<SoDetails />} />
      },
      {
        path: '/store_home',
        element: <ProtectedRoute element={<StoreHome />} />
      },
      {
        path: '/update_password',
        element: <ProtectedRoute element={<UpdatePassword />} />
      },
      {
        path: '/store_home/:storeid',
        element: <ProtectedRoute element={<Store />} />
      },
      {
        path: '/invoice_journey_start',
        element: <ProtectedRoute element={<ViewSoInvoice />} />
      },
      {
        path: '/invoice_journey_start/:soid/:sonumber',
        element: <ProtectedRoute element={<Di />} />
      },
      {
        path: '/store_home/:storeid/:modelid',
        element: <ProtectedRoute element={<BatchDetails />} />
      },
      {
        path: '/reports',
        element: <ProtectedRoute element={<Reports />} />
      },
      {
        path: '/order-booking',
        element: <ProtectedRoute element={<OrderBookingReport />} />
      },
      {
        path: '/lead-report',
        element: <ProtectedRoute element={<LeadDetailsReport />} />
      },
      {
        path: '/invoice-report',
        element: <ProtectedRoute element={<InvoiceReport />} />
      },
      {
        path: '/invoice-wise-report',
        element: <ProtectedRoute element={<AggInvoiceReport />} />
      },
      {
        path: '/credit-note-wise-report',
        element: <ProtectedRoute element={<AggCreditNoteReport />} />
      },
      {
        path: '/invoice',
        element: <ProtectedRoute element={<Invoice />} />
      },
      {
        path: '/foc',
        element: <ProtectedRoute element={<FOC />} />
      },
      {
        path: '/foc-lead-journey/:id',
        element: <ProtectedRoute element={<FocLeadJourney />} />
      },
      {
        path: '/view_foc_so',
        element: <ProtectedRoute element={<ViewFocSalesOrder />} />
      },
      {
        path: '/view_foc_so/:soid',
        element: <ProtectedRoute element={<FocSoDetails />} />
      },
      {
        path: '/foc_invoice_journey_start',
        element: <ProtectedRoute element={<ViewFocSoInvoice />} />
      },
      {
        path: '/foc_invoice_journey_start/:soid/:sonumber',
        element: <ProtectedRoute element={<FocDi />} />
      },
      {
        path: '/purchase_request',
        element: <ProtectedRoute element={<PurchaseRequest />} />
      },
      {
        path: '/view_pr',
        element: <ProtectedRoute element={<ViewPR />} />
      },
      {
        path: '/view_pr/:prid',
        element: <ProtectedRoute element={<PRDetail />} />
      },
      {
        path: '/purchase/add_vendor',
        element: <ProtectedRoute element={<AddVendor />} />
      },
      {
        path: '/purchase/view_vendors',
        element: <ProtectedRoute element={<ViewVendors />} />
      },

      {
        path: '/purchase/view_po',
        element: <ProtectedRoute element={<ViewPO />} />
      },
      {
        path: '/purchase/create_quotation',
        element: <ProtectedRoute element={<CreateQuotation />} />
      },
      {
        path: '/purchase/view_quotations',
        element: <ProtectedRoute element={<ViewQuotation />} />
      },
      {
        path: '/purchase/view_wo',
        element: <ProtectedRoute element={<ViewWorkOrder />} />
      },
      {
        path: '/purchase/material-inspection/:poid',
        element: <ProtectedRoute element={<MaterialInspection />} />
      },
      {
        path: '/purchase/view_debit_notes',
        element: <ProtectedRoute element={<ViewDebitNotes />} />
      }
    ]
  }
])

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <CacheBuster
    currentVersion={version}
    isEnabled={isProduction} // enable only in production
    isVerboseMode={false} // flip to true while debugging
    loadingComponent={null} // optional loading component while meta check runs
    metaFileDirectory={'.'} // use '.' if meta.json is at project's public root
  >
    <RouterProvider router={appRouter} />
  </CacheBuster>
)

// IMPORTANT: unregister service worker to avoid stale cached bundles.
// If you require PWA behavior, implement a proper update flow instead of keeping register()
serviceWorkerRegistration.unregister()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
